export default __webpack_public_path__ + "static/media/sneaker red.4294fbcf.png";